import { Directive } from '@angular/core';

@Directive({
  selector: '[nttTrailing]',
})
export class NttTrailing {}
